import React, {useState} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@mui/material";

SuspendDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    busy: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

/**
 * The reason a member suspends an access by hand: the words at issue, what the team will
 * check when deciding whether to reactivate.
 */
function SuspendDialog({open, busy, onConfirm, onClose}) {
    const [reason, setReason] = useState("");

    return (
        <Dialog open={open} onClose={busy ? undefined : onClose} fullWidth maxWidth="sm">
            <DialogTitle><FormattedMessage id="personalShopper.suspension.dialog.title" /></DialogTitle>
            <DialogContent>
                <DialogContentText sx={{marginBottom: "12px"}}><FormattedMessage id="personalShopper.suspension.dialog.help" /></DialogContentText>
                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    minRows={2}
                    label={<FormattedMessage id="personalShopper.suspension.dialog.reason" />}
                    value={reason}
                    onChange={(event) => setReason(event.target.value)}
                    inputProps={{maxLength: 500}}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={busy} sx={{textTransform: "none"}}>
                    <FormattedMessage id="personalShopper.suspension.dialog.cancel" />
                </Button>
                <Button variant="contained" color="error" disabled={busy || reason.trim() === ""} onClick={() => onConfirm(reason.trim())} sx={{textTransform: "none"}}>
                    <FormattedMessage id="personalShopper.suspension.dialog.confirm" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default SuspendDialog;
